import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

export const useOutsideClick = <T extends HTMLElement = HTMLDivElement>(
    onOutside: () => void,
): RefObject<T | null> => {
    const ref = useRef<T>(null);
    const handler = useRef(onOutside);

    handler.current = onOutside;

    useEffect(() => {
        const handleClick = (event: MouseEvent): void => {
            const target = event.target as Node | null;
            if (target && ref.current && !ref.current.contains(target)) handler.current();
        };

        document.addEventListener('click', handleClick, true);
        return () => document.removeEventListener('click', handleClick, true);
    }, []);

    return ref;
};